import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Main layout component that provides consistent header, footer, and scroll behavior.
 *
 * @param props - Component props.
 * @param props.children - Child content to render in the main section.
 * @returns The layout wrapper with header, main content, and footer.
 */
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-obsidian text-white selection:bg-sapphire-500/30 selection:text-white">
      <Header />
      <main className="flex-grow pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
};
